var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8311 10.797C13.4282 11.7499 12.798 12.5896 11.9956 13.2426C11.1932 13.8957 10.243 14.3422 9.22814 14.5432C8.21329 14.7442 7.16466 14.6935 6.17391 14.3956C5.18317 14.0977 4.28048 13.5617 3.54477 12.8343C2.80906 12.107 2.26272 11.2105 1.95353 10.2232C1.64434 9.2359 1.5817 8.18791 1.7711 7.17083C1.9605 6.15375 2.39616 5.19855 3.04 4.38874C3.68384 3.57894 4.51625 2.93917 5.46446 2.52539",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3336 8.33357C14.3336 7.50183 14.1697 6.67824 13.8515 5.90982C13.5332 5.14139 13.0666 4.44318 12.4785 3.85506C11.8904 3.26693 11.1922 2.80041 10.4238 2.48211C9.65533 2.16382 8.83174 2 8 2V8.33357H14.3336Z",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoters);
export default __webpack_public_path__ + "static/media/voters.01ab14a96c3bb9262b86fbdbc6fce2b2.svg";
export { ForwardRef as ReactComponent };